<template>
  <section class="fo-card">
    <div class="fo-card-loading loading loading-lg" v-if="loading"></div>
    <div class="fo-card-head">
      <h2 class="fo-card-title">Saldo por conta</h2>
      <router-link to="/financial/statements">Abrir extrato</router-link>
    </div>

    <template v-if="accounts.items.length > 0">
      <div class="fo-rows fo-accounts">
        <router-link class="fo-line fo-line-account" v-for="account in accounts.items"
                     :key="account.id" to="/financial/statements">
          <span class="fo-account-icon">
            <fa-icon :icon="['fal', account.cashier ? 'cash-register' : 'university']"/>
          </span>
          <span class="fo-line-main">
            <strong>{{ account.name }}</strong>
            <span>{{ caption(account) }}</span>
          </span>
          <span class="fo-line-value" :class="{ 'is-negative': account.balance < 0 }">
            {{ money(account.balance) }}
          </span>
        </router-link>
      </div>
      <div class="fo-total">
        <span>Total consolidado</span>
        <strong :class="{ 'text-error': accounts.total < 0 }">{{ money(accounts.total) }}</strong>
      </div>
      <div class="fo-aside" v-if="cardReceivables.value > 0">
        <div class="fo-aside-row">
          <span class="fo-line-main">
            <strong>A cair das adquirentes</strong>
            <span>cartões · líquido previsto nos próximos {{ cardReceivables.days }} dias</span>
          </span>
          <span class="fo-line-value">{{ money(cardReceivables.value) }}</span>
        </div>
        <span class="fo-hint">Fora do total: ainda não é dinheiro em conta.</span>
      </div>
    </template>
    <div class="fo-empty" v-else>
      <fa-icon :icon="['fal', 'university']"/>
      <strong>Nenhuma conta ativa nesta filial</strong>
      <span>Cadastre as contas bancárias e o caixa para acompanhar os saldos aqui.</span>
      <router-link class="btn btn-sm" to="/financial/bank-accounts">Cadastrar conta</router-link>
    </div>
  </section>
</template>

<script>
import { money, shortDate } from './helpers';

export default {
  props: {
    accounts: {
      type: Object,
      required: true,
    },
    cardReceivables: {
      type: Object,
      required: true,
    },
    hidden: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    money(value) {
      return money(value, this.hidden);
    },
    caption(account) {
      if (account.cashier) {
        return 'Caixa';
      }
      const { statement } = account;
      if (!statement || !statement.lastDate) {
        return 'Conta bancária · sem extrato importado';
      }
      const pending = statement.pending === 1
        ? '1 linha sem conciliar'
        : `${statement.pending} linhas sem conciliar`;
      return `Extrato até ${shortDate(statement.lastDate)} · ${statement.pending > 0 ? pending : 'conciliado'}`;
    },
  },
};
</script>
